
import { listingStatus, shippingType, timeRangeOptions } from "@/utils/options";

const linkStatusOptions = [
    {id: 'Linked', text: '已关联'},
    {id: 'NotLinked', text: '未关联'},
]

export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '国家店铺',
    prop: 'countryMarketValue',
    components: [{
        name: 'gj-country-server-select',
        prop: 'countryMarketValue'
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: {
        countryIds: [],
        marketIds: []
    }
}, {
    label: '状态',
    prop: 'status',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'status',
        propsData: {
            options: listingStatus,
            placeholder: '全部状态'
        }
    }],
    defaultValue: ''
}, {
    label: '关联状态',
    prop: 'linkedStatus',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'linkedStatus',
        propsData: {
            placeholder: '关联状态',
            options: linkStatusOptions
        }
    }]
}, {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
            placeholder: '时间范围',
            options: timeRangeOptions,
            style: {
                marginLeft: '8px'
            }
        }
    }],
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
}, {
    prop: 'dateType',
    defaultValue: 'statistics'
}, {
    label: '负责人',
    labelWidth: '120px',
    prop: 'chargeIdList',
    isFormItem: true,
    components: [{
        name: 'gj-charger-select',
        prop: 'chargeIdList',
        propsData: {
            placeholder: '全部负责人',
            collapseTags: true
        }
    }],
    defaultValue: []
}, {
    label: '品牌',
    labelWidth: '120px',
    prop: 'brandId',
    isFormItem: true,
    components: [{
        name: 'gj-brand-select',
        prop: 'brandId',
        propsData: {
            placeholder: '品牌',
            active: true
        }
    }],
    defaultValue: ''
}, {
    label: '品类',
    labelWidth: '120px',
    prop: 'categoryIds',
    isFormItem: true,
    components: [{
        name: 'gj-category-select',
        prop: 'categoryIds',
        propsData: {
            placeholder: '品类',
            multiple: true,
            active: true
        }
    }],
    defaultValue: []
}, {
    label: '配送渠道',
    labelWidth: '120px',
    prop: 'fulfillment',
    isFormItem: true,
    components: [{
        name: 'gj-select',
        prop: 'fulfillment',
        propsData: {
            options: shippingType,
            placeholder: '配送渠道'
        }
    }],
    defaultValue: ''
}]
